import { em, math } from 'polished'
import styled from 'styled-components'

import { TextFieldError } from 'components/_form/TextField/styles'
import LinkInlineArrowShort from 'components/LinkInlineArrowShort'
import { linkInverted } from 'styles/mixins'

const closeButton = em(42)

export const Wrapper = styled.div`
  position: relative;
  margin-bottom: ${em(20)};
  margin-left: -${p => p.theme.indents.baseIndentXs};
  margin-right: -${p => p.theme.indents.baseIndentXs};
  background: ${p =>
    p.isOpened ? p.theme.colors.aquaHaze : p.theme.colors.catskillWhite};
  padding: ${em(15)} ${em(20)};

  ${p => p.theme.mq.upMd} {
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    background: none;
  }
`

export const PromocodeAnimation = styled.div`
  transition: opacity ${p => p.theme.animation.timeStandard} ease-out;

  ${({ state }) =>
    state === 'entering' &&
    `
    position: absolute;
  `}

  ${({ state }) =>
    state === 'entered' &&
    `
    opacity: 1;
  `}

  ${({ state }) =>
    (state === 'entering' || state === 'exited' || state === 'exiting') &&
    `
    opacity: 0;
  `}

  ${({ state }) =>
    (state === 'entering' || state === 'exiting') &&
    `
    pointer-events: none;
  `}

  ${p => p.theme.mq.upMd} {
    ${({ state }) =>
      state === 'entering' &&
      `
      top: 0;
      left: 0;
    `}
  }
`

export const FormStyled = styled.form`
  margin-bottom: 0;
`

export const FormInner = styled.div`
  position: relative;

  ${p => p.theme.mq.upMd} {
    display: flex;
    align-items: center;
  }
`

export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  font-size: ${p => p.theme.typography.cartFontSize};
  margin-bottom: ${em(20)};

  // to show full error message
  & ${TextFieldError} {
    position: relative;
    height: auto;
    overflow: visible;
  }

  ${p => p.theme.mq.upMd} {
    top: -${p => math(`${p.theme.typography.textSmallForms} / 2`)};
    width: auto;
    max-width: ${em(140)};
    font-size: ${p => p.theme.typography.fontSize};
    margin-bottom: 0;

    & ${TextFieldError} {
      position: absolute;
    }
  }
`

export const ButtonWrapper = styled.div`
  width: 100%;
  max-width: ${em(280)};
  margin: 0 auto;

  & > button {
    width: 100%;
  }

  ${p => p.theme.mq.upMd} {
    width: auto;
    padding-left: ${em(20)};
    margin: 0;
  }
`

export const ButtonText = styled.span`
  display: block;
  padding: 0 ${em(20)};
`

export const IconBox = styled.div`
  display: inline-block;
  position: relative;
  top: ${em(5)};
  width: ${p => p.theme.blocks.iconInfoW};
  height: ${p => p.theme.blocks.iconInfoW};
  transform: rotateZ(0);
  transition: transform ${p => p.theme.animation.timeStandard} linear;
  -webkit-backface-visibility: hidden;

  ${p => p.theme.mq.hover} {
    &:hover {
      transform: rotateZ(180deg);
    }
  }

  ${p => p.theme.mq.upMd} {
    left: -${em(20)};
    width: ${closeButton};
    height: ${closeButton};
  }
`

export const CloseWrapper = styled.div`
  position: absolute;
  ${linkInverted}
  display: block;
  z-index: 30;
  margin-top: -${em(5)};
  right: 0;
  line-height: ${p => p.theme.typography.inputLh};
  -webkit-backface-visibility: hidden;

  ${p => p.theme.mq.upMd} {
    left: -${em(33)};
    right: initial;
    margin-top: 0;
    margin-right: ${em(10)};
  }
`

export const StatusWrapper = styled.div`
  display: flex;

  ${p => p.theme.mq.upMd} {
    display: block;
    max-width: ${em(245)};
    margin-bottom: ${em(3)};
  }
`

export const StatusIcon = styled.div`
  position: relative;
  line-height: 0;
  width: ${p => p.theme.blocks.iconInfoW};
  height: ${p => p.theme.blocks.iconInfoW};
  // Align top icon and text
  top: 0.2em;
  flex-shrink: 0;
  margin-right: ${em(10)};
  border-radius: 50%;
  background-color: ${p =>
    p.bgColor ? p.theme.colors[p.bgColor] : p.theme.colors.transparent};

  ${p => p.theme.mq.upMd} {
    position: absolute;
    top: 0.25em;
    left: ${p => math(`-${p.theme.blocks.iconInfoW} - ${em(10)}`)};
    margin-right: 0;
  }
`

export const ResetWrapper = styled.div`
  margin-left: ${p => math(`${p.theme.blocks.iconInfoW} + ${em(10)}`)};

  ${p => p.theme.mq.upMd} {
    margin-left: 0;
  }
`

export const LinkWrapper = styled.div`
  border-bottom: 1px solid ${p => p.theme.colors.transparent};
`

export const LinkInlineArrowShortStyled = styled(LinkInlineArrowShort)`
  display: inline-block;
  position: relative;
  top: -1px;
  line-height: 1;

  ${p => p.theme.mq.upMd} {
    padding-left: 0;
    padding-top: ${p => math(`${p.theme.typography.textSmallForms} / 2`)};
    margin-left: 0;
  }
`
